import { defineComponent, reactive, onMounted } from '@vue/composition-api';
import { alertDialogue, generalError } from '@/functions/system-modal-functions';
import axios from 'axios';
import { i18n } from '@/utilities/vue-i18n';
import { SettingsContext } from '@/utilities/settings-context';
import {createPageContext} from "@/components/navbar-box/page-context";
import {validatePassword} from "@noordigitalagency/accounts-ledigajobb";

export default defineComponent({

  setup(_, context) {

    const model = reactive({password: '', token: ''});

    const settings = reactive({passwordVisible: false});

    model.token = context.root.$route.params.token;

    onMounted(async () => {

      if (model.token == null)
      {
        await context.root.$router.replace({name: 'Sign In'});
      }
    });

    const submit = async () => {

      try {

        await axios.post(SettingsContext.getApiUrl('ResetPassword'), {

            token: model.token,

            password: model.password,

            confirmPassword: model.password,
        });

        await context.root.$router.replace({name: 'Sign In', params: {message: 'reset'}});

      } catch {

        await generalError(false);
      }
    }

    const pageContext = createPageContext({
      actions: [],
      title: {text: i18n.t('pages.reset-password.select-new') as string},
      breadcrumb: {
        showHome: false,
        segments: []
      }
    });

    return {

      model,

      validatePassword: (password: string) => validatePassword(password, SettingsContext.get('signUp.passwordLength') as number),

      submit,

      settings,

      passwordLength: SettingsContext.get('signUp.passwordLength') as number,

      pageContext
    }
  }
})